export default __webpack_public_path__ + "static/media/chooseTheater.62307e30.png";